import { render, staticRenderFns } from "./battle.vue?vue&type=template&id=669d690f&scoped=true"
import script from "./battle.vue?vue&type=script&lang=js"
export * from "./battle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d690f",
  null
  
)

export default component.exports